/**
 * `chat_topic` is the only topic field on the conversation payload that carries the `parent_chat`
 * self-join, so it is the only one that can build the full `parent - child` name. That is why this
 * module exists — do not swap in `professional_chat_topic` (no parent include) or
 * `customer_chat_topic_tag` (a system Tag, no parent concept).
 *
 * Older copies of the same logic live in ChatCardV2026.vue, CustomerInformation.vue and
 * Conversation.vue; keep them in step rather than "fixing" one of them.
 */
export function displayChatTopic (chatTopic) {
  if (!chatTopic) {
    return ''
  }
  if (chatTopic.parent_id !== 0 && chatTopic.parent_chat) {
    return `${chatTopic.parent_chat.name} - ${chatTopic.name}`
  } else {
    return `${chatTopic.name}`
  }
}
